export const poslovno_uvjetovani_otkaz_gospodarski_1 = {
  templateId: 8.1,
  category: 11,
  templateTitle: 'Poslovno uvjetovani otkaz - gospodarski razlozi',
  templateDescription: `<p>Ako prestane potreba za obavljanjem određenog posla zbog gospodarskih razloga, poslodavac može, ukoliko za to ima opravdani razlog, otkazati ugovor o radu uz propisani ili ugovoreni otkazni rok (redoviti otkaz).</p>`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Ovaj tekst, kao i dolje navedeni primjer odluke odnose se na situacije davanja otkaza u kojima poslodavac zapošljava dvadeset i više radnika te je kod poslodavca donesen pravilnik o radu (obveza poslodavca koji zapošljava 20 i više radnika).</p>
    <p>Poslodavac može otkazati ugovor o radu uz propisani ili ugovoreni otkazni rok (redoviti otkaz), ako za to ima opravdani razlog, u slučaju ako prestane potreba za obavljanjem određenog posla zbog gospodarskih, tehnoloških ili organizacijskih razloga. </p>
    <p>Ovaj primjer se odnosi na poslovno uvjetovani otkaz uslijed gospodarskih razloga (npr. smanjeni obujam nabave robe, smanjeni obujam prodaje robe ili bilo koji smanjeni obujam odnosno prestanak poslova na kojima je radnik zaposlen te sve druge gospodarske okolnosti koje na sličan utječu na posao radnika kojemu se otkazuje ugovor o radu). </p>
    <p><strong>Otkaz mora biti u pisanom obliku.</strong> </p>
    <p>Poslodavac mora u pisanom obliku <strong>obrazložiti</strong> otkaz. </p>
    <p><strong>Obrazloženje mora sadržavati mjerodavne razloge na kojima se temelji odluka o otkazu.</strong> </p>
    <p>Razlozi otkaza navedeni u obrazloženju moraju biti jasni i nedvojbeni.</p>
    <p>U eventualnom sudskom postupku osporavanja otkaza, postupak se ograničava na razloge navedene u obrazloženju te se novi dokazi i razlozi ne mogu isticati, zbog toga je iznimno bitno da obrazloženje sadrži mjerodavne razloge.</p>
    <p>Sadržaj obrazloženja mora se odnositi na vrstu otkaza koji se daje radniku te isti moraju biti usklađeni, u protivnom je otkaz nezakonit.</p>
    <p><strong>Otkaz se mora dostaviti osobi kojoj se otkazuje.</strong> </p>
    <p>Ako postupak dostave nije uređen kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili pravilnikom o radu, na dostavu odluka o otkazu ugovora o radu, primjenjuju se na odgovarajući način odredbe o dostavi iz propisa kojim je uređen parnični postupak. </p>
    <p>Npr. otkaz se može dostaviti preporučenom poštanskom pošiljkom s povratnicom ili osobno na radnom mjestu uz potvrdu primitka, no ukoliko radnik ne želi primiti otkaz, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka, čime se prema sudskoj praksi smatra da je otkaz valjano dostavljen. Otkaz se može dostaviti i putem javnog bilježnika. </p>
    <p>Zakonom o radu nisu propisani pojedini specifični razlozi otkaza ugovora o radu, nego poslodavac razlog za svaki otkaz utvrđuje od slučaja do slučaju. Dakle, zakon daje samo okvir i propisuje za određene vrste otkaza pretpostavke osnovanosti, a na poslodavcu je da svaki specifični razlog posebno utvrdi i obrazloži. </p>
    <p><strong>Ugovor o radu sklopljen na određeno vrijeme može se redovito otkazati samo ako je takva mogućnost otkazivanja predviđena ugovorom.</strong></p>
    <p>Nakon što je poslodavac odlučio o razlozima otkaza, potrebno je utvrditi otkazni rok te pravo na otpremninu. Radnik se može odreći otkaznog roka i otpremnine, a navedena pitanja pojašnjavaju se u nastavku ovog teksta. </p>
    <p><strong>Otkazni rok</strong> počinje teći danom dostave otkaza ugovora o radu. </p>
    <p>Otkazni rok ne teče za vrijeme trudnoće, privremene nesposobnosti za rad, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada u skraćenom radnom vremenu zbog pojačane njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada u skraćenom radnom vremenu radi skrbi i njege djeteta s težim smetnjama u razvoju prema posebnom propisu te za vrijeme privremene nesposobnosti za rad tijekom liječenja ili oporavka od ozljede na radu ili profesionalne bolesti, te vršenja dužnosti i prava državljana u obrani. </p>
    <p><strong>Otkazni rok teče za vrijeme godišnjeg odmora, plaćenog dopusta te razdoblja privremene nesposobnosti za rad radnika kojeg je poslodavac u otkaznom roku oslobodio obveze rada, osim ako kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu nije drukčije uređeno. </strong> </p>
    <p>Ako je došlo do prekida tijeka otkaznog roka zbog privremene nesposobnosti za rad radnika, radni odnos tom radniku prestaje najkasnije istekom šest mjeseci od dana uručenja odluke o otkazu ugovora o radu. </p>
    <p>Najmanje trajanje otkaznog roka je: </p>
    <p>1) dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno manje od jedne godine,</p>
    <p>2) mjesec dana, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno jednu godinu,</p>
    <p>3) mjesec dana i dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno dvije godine,</p>
    <p>4) dva mjeseca, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno pet godina,</p>
    <p>5) dva mjeseca i dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno deset godina,</p>
    <p>6) tri mjeseca, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno dvadeset godina. </p>
    <p>Otkazni rok radniku koji je kod poslodavca proveo u radnom odnosu neprekidno dvadeset godina, povećava se za dva tjedna ako je radnik navršio pedeset godina života, a za mjesec dana ako je navršio pedeset pet godina života. </p>
    <p>Rokovi u radnim odnosima računaju se na sljedeći način: </p>
    <p>- rok određen u danima počinje teći prvog dana poslije događaja od kojega se rok računa, a završava istekom posljednjeg dana roka, </p>
    <p>- rok određen u tjednima, mjesecima ili godinama završava onoga dana koji se po imenu i broju podudara s danom nastanka događaja od kojega rok počinje teći, a ako takva dana nema u posljednjem mjesecu, kraj roka pada na posljednji dan toga mjeseca. </p>
    <p>Npr. ako  otkazni rok počinje teći 15. siječnja (14-og je uručen otkaz) i traje mjesec dana, isti, prema navedenoj odredbi ističe 15.veljače ili ako otkazni rok počinje teći 5. lipnja (4-og je uručen otkaz) i traje dva tjedna, isti, prema navedenoj odredbi ističe 19. lipnja. </p>
    <p>Ako posljednji dan roka pada na dan kad je zakonom određeno da se ne radi, kao posljednji dan roka računa se sljedeći radni dan. </p>
    <p><strong>Radnik se nakon primitka redovitog otkaza ugovora u radu može odreći prava na otkazni rok, jer je to pravo u trenutku primitka otkaza dospjelo. Odricanje prava na otkazni rok u vrijeme početka ili pak tijekom trajanja otkaznog roka ima za pravnu posljedicu prestanak ugovora o radu u trenutku kad je odricanje radnika od prava na otkazni rok dostavljeno poslodavcu                        (rješenje Vrhovnog suda Republike Hrvatske, Rev 950/1999. od 17. listopada 1999.). </strong></p>
    <p>Primjerak izjave o odricanju od otkaznog roka možete pogledati <a class="local-link" href="/contract?template=18">ovdje</a>.</p>
    <p><strong>Otpremnina</strong> je pravo radnika s obzirom na dužinu prethodnog neprekidnog trajanja radnog odnosa s tim poslodavcem. </p>
    <p>Radnik kojemu poslodavac otkazuje <strong>nakon dvije godine neprekidnog rada</strong>, osim ako se otkazuje zbog razloga uvjetovanih ponašanjem radnika, ima pravo na otpremninu. </p>
    <p>Otpremnina se ne smije ugovoriti, odnosno odrediti u iznosu manjem od jedne trećine prosječne mjesečne plaće koju je radnik ostvario u tri mjeseca prije prestanka ugovora o radu, za svaku navršenu godinu rada kod toga poslodavca. </p>
    <p>Ako zakonom, kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu nije određeno drukčije, ukupan iznos otpremnine ne može biti veći od šest prosječnih mjesečnih plaća koje je radnik ostvario u tri mjeseca prije prestanka ugovora o radu. </p>
    <p>Radnik koji je pretrpio ozljedu na radu, odnosno koji je obolio od profesionalne bolesti, a kojemu nakon završenog liječenja, oporavka i profesionalne rehabilitacije, poslodavac ne može osigurati odgovarajuće poslove prema Zakonu o radu, ima pravo na otpremninu najmanje u dvostrukom iznosu, ako je ispunio uvjete za stjecanje prava na otpremninu, osim u slučaju da je odbio ponuđene poslove. </p>
    <p><strong>Obveza plaćanja otpremnine dospijeva s danom prestanka radnog odnosa, tj. istekom otkaznog roka. </strong> </p>
    <p><strong>Radnik se može odreći prava na otpremninu, u cijelosti ili djelomično, a odricanje od otpremnine dopušteno je tek nakon njezinog dospijeća, stoga bilo kakva izjava o odricanju prije dospijeća ne proizvodi pravne učinke (Vrhovni sud Republike Hrvatske, u predmetu broj Revr 228/11-2 od 20. travnja 2011.). </strong> </p>
    <p>Osim toga, poslodavac je dužan kod otkaza pridržavati se i drugih obveza iz Zakona o radu koje se navode u nastavku. </p>
    <p>Poslodavac koji je poslovno uvjetovanim otkazom otkazao radniku, ne smije šest mjeseci od dana dostave odluke o otkazu ugovora o radu radniku, na istim poslovima zaposliti drugog radnika. </p>
    <p>Ako u navedenom roku nastane potreba zapošljavanja zbog obavljanja istih poslova, poslodavac je dužan ponuditi sklapanje ugovora o radu radniku kojem je otkazao iz poslovno uvjetovanih razloga. </p>
    <p>Poslodavac koji zapošljava dvadeset i više radnika, pri odlučivanju o poslovno uvjetovanom otkazu, poslodavac mora voditi računa o trajanju radnog odnosa, starosti i obvezama uzdržavanja koje terete radnika te iste mora navesti u obrazloženju otkaza - <strong>ovaj primjer ne sadržava navedene odredbe. </strong> </p>
    <p>Poslodavac je dužan obavijestiti radnike koji su kod njega zaposleni na temelju ugovora o radu na <strong>određeno vrijeme</strong> o poslovima za koje bi ti radnici mogli sklopiti kod poslodavca ugovor o radu na neodređeno vrijeme te im omogućiti usavršavanje i obrazovanje pod istim uvjetima kao i radnicima koji su sklopili ugovor o radu na neodređeno vrijeme. </p>
    <p><strong>Ukoliko je kod poslodavca utemeljeno radničko vijeće odnosno kod poslodavca postoji imenovan sindikalni povjerenik (koji preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu), poslodavac je dužan savjetovati se (za razliku od suglasnosti, gdje je pozitivno mišljenje preduvjet donošenja odluke) s radničkim vijećem/sindikalnim povjerenikom prije odluke o otkazu. Podrazumijeva se da poslodavac ima navedenu obvezu samo ukoliko je radničko vijeće utemeljeno (ukoliko su radnici formirali radničko vijeće), odnosno ukoliko je sindikat pisano obavijestio poslodavca o imenovanju sindikalnog povjerenika, na način i pod uvjetima propisanim Zakonom o radu. Radničko vijeće/sindikalni povjerenik je u tom smislu dužno u roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. Ako se radničko vijeće/sindikalni povjerenik ne očituje o namjeravanoj odluci u navedenom roku, smatra se da nema primjedbi i prijedloga. </strong> </p>
    <p><strong>Važno je naglasiti da poslodavac nije vezan očitovanjem radničkog vijeća/sindikata te svoju odluku može donijeti čak iako se navedeni protive istoj, no dužan je savjetovati se, jer je u protivnom odluka o otkazu ništetna (ne proizvodi pravne učinke). </strong> </p>
    <p>Ipak, poslodavac  može samo uz prethodnu suglasnost radničkog vijeća/sindikalnog povjerenika donijeti odluku o:</p>
    <p>1) otkazu članu radničkog vijeća, </p>
    <p>2) otkazu kandidatu za člana radničkog vijeća koji nije izabran, u razdoblju od tri mjeseca nakon utvrđenih konačnih rezultata izbora, </p>
    <p>3) otkazu radniku kod kojeg je zbog ozljede na radu ili profesionalne bolesti došlo do smanjenja radne sposobnosti uz preostalu radnu sposobnosti ili do smanjenja radne sposobnosti uz djelomični gubitak radne sposobnosti, odnosno otkazu radniku osobi s invaliditetom, </p>
    <p>4) otkazu radniku s navršenih šezdeset godina odnosno starijem od šezdeset godina,</p>
    <p>5) otkazu predstavniku radnika u organu poslodavca. </p>
    <p>Ukoliko se otkaz daje navedenim osobama, u tom smislu je potrebno prethodno ishoditi suglasnost radničkog vijeća/sindikalnog povjerenika.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong> - Nedopušteni razlozi za otkaz ugovora o radu</strong></p>
    <p>Pojašnjenje: ako sud utvrdi da otkaz poslodavca nije dopušten i da radni odnos nije prestao, naložiti će vraćanje radnika na posao, a radnik će imati i pravo na naknadu plaće umanjenu za iznos plaće koju je kroz to vrijeme primao. Radnik koji osporava dopuštenost otkaza može tražiti da sud privremeno, do okončanja spora, naloži njegov povratak na posao. </p>
    <p><strong> - Tumačenje da otkaz ne može biti uručen za vrijeme trudnoće, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada s polovicom punog radnog vremena radi pojačane brige i njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju, odnosno u roku od petnaest dana od prestanka trudnoće ili prestanka korištenja tih prava, poslodavac ne smije otkazati ugovor o radu trudnici i osobi koja se koristi nekim od tih prava. </strong></p>
    <p>Pojašnjenje: otkaz može biti uručen, no otkazni rokovi počinju teći tek po isteku spomenutih okolnosti pa time radni odnos ne može niti prestati sve dok traju spomenute okolnosti.</p>
    <p><strong>- Netočno određivanje  trajanja i računanje tijeka otkaznog roka</strong></p>
    <p>Pojašnjenje: netočno računanje i određivanje tijeka otkaznog roka može dovesti do gubitka određenih prava radnika, a time i pokretanja sudskih postupaka radi ostvarenja istih. </p>
    <p><strong> - Dostava otkaza nije izvršena u skladu sa Zakonom odnosno Pravilnikom o radu</strong></p>
    <p>Pojašnjenje: u slučaju dostave koja nije obavljena zakonito, smatra se da otkaz nije niti uručen, a time ne mogu niti nastupiti posljedice otkaza. </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Pravilnik o radu.</p>
  `,

  sides: [
    {
      prefix: 'Na temelju Zakona o radu i Pravilnika o radu,',
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'donosi sljedeću',
  title: "ODLUKU O OTKAZU UGOVORA O RADU",
  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: 'text', content: 'Radniku' },
            { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
            { type: "text", content: "," },
            { type: 'text', content: 'iz',},
            { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
            { type: 'text', content: ',' },
            { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
            { type: "text", content: "," },
            { type: 'text', content: 'OIB:' },
            { type: "input",  required: true,},
            { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
            { type: 'text', content: 'otkazuje se ugovor o radu na' },
            { type: "input",  required: true, placeholder: "određeno/neodređeno"},
            { type: 'text', content: 'vrijeme, sklopljen dana'},
            { type: 'input', value: '', required: true },
            { type: 'text', content: 'godine,' },
            { type: 'text', content: 'zbog gospodarskih razloga (poslovno uvjetovani otkaz).' },
          ]
        }]
    },
    {
      title: '',
      mandatory: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: false,
          content: 'Radniku prestaje radni odnos uz otkazni rok u trajanju određenom ovom Odlukom.'
        }]
    },
    {
      title: '',
      mandatory: true,
      statements: [
        {
          type: 'input',
          mandatory: true,
          editable: false,
          help: 'Za točan izračun otkaznih rokova molimo pogledajte gore navedeni uvodni tekst te pogledajte odredbe Pravilnika o radu.',
          parts: [
            { type: 'text', content: 'Ugovor o radu otkazuje se uz otkazni rok u trajanju od ' },
            { type: 'input', requred: true },
            { type: 'text', content: ', a koji počinje teći od dana dostave ove Odluke Radniku.' },
          ]
        }]
    },
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: 'choice',
          mandatory: true,
          editable: true,
          choices: [
            'Za vrijeme otkaznog roka, Radnik se oslobađa obveze rada.',
            'Za vrijeme otkaznog roka, Radnik se ne oslobađa obveze rada.',
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        },
      ]
    },
    {
      title: '',
      mandatory: false,
      statements: [
        {
          type: 'choice',
          mandatory: true,
          editable: true,
          help: 'Radnik kojemu poslodavac otkazuje nakon dvije godine neprekidnog rada, osim ako se otkazuje zbog razloga uvjetovanih ponašanjem radnika, ima pravo na otpremninu.  Način određivanja otpremnine i rokovi isplate otpremnine razmatraju se u uvodnom tekstu.\r\nRadnik koji radi kod poslodavca manje od dvije godine neprekidno, nema pravo na otpremninu.',
          choices: [
            'Radnik ima pravo na otpremninu.',
            'Radnik nema pravo na otpremninu.',
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        },
      ]
    },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `OBRAZLOŽENJE U NASTAVKU JE DANO SAMO RADI PRIMJERA, NO BUDUĆI JE OBRAZLOŽENJE NAJBITNIJI DIO ODLUKE O OTKAZU, PRIJE IZRADE OBRAZLOŽENJA OBAVEZNO PROČITAJTE UVODNI TEKST GORE VEZAN UZ OBRAZLOŽENJE.\r\nU SVAKOM SLUČAJU, RAZLOZI OTKAZA MORAJU BITI JASNI I NEDVOSMISLENI TE USKLAĐENI S OBZIROM NA VRSTU OTKAZA KOJA SE DAJE RADNIKU. TAKOĐER, RAZLOZI OTKAZA NAVEDENI U OBRAZLOŽENJU SE U SLUČAJU SUDSKOG SPORA NE MOGU PROŠIRIVATI NOVIM DOKAZIMA I RAZLOZIMA.\r\nPrimjer obrazloženja:\r\n"Poslodavac je odluku o otkazu donio zbog prestanka potrebe rada na radnom mjestu na kojemu je Radnik zaposlen uslijed smanjenog obujma nabave robe i prodaje robe, što izravno utječe na obujam posla u skladištu."`,
          help: 'Za svaki otkaz potrebno je posebno obrazložiti točno određeni razlog otkazivanja koji može biti različit s obzirom na specifičnost djelatnosti i organizacije posla poslodavca.'
        }]
    },
       {
          title: "",
          dummy: true,
          mandatory: true,
          statements: [
          
            {
              type: "input",
              editable: false,
              mandatory: true,
              parts: [  
              {type: "text", content: "Budući da Poslodavac zapošljava više od devetnaest radnika, pri donošenju ove Odluke uzete su u obzir sljedeće okolnosti:"},
              { type: "text", newline:"true", content: "\r\n- da je radnik u radnom odnosu proveo ukupno:" },
              { type: "input", value: "", required: true },
              { type: "text",  content: "godina," },
              { type: "input", value: "", required: true },
              { type: "text",  content: "mjeseci," },
              { type: "input", value: "", required: true },
              { type: "text",  content: "dana," },
             

              { type: "text", newline:"true", content: "\r\n- da radnik ima" },
              { type: "input", value: "", required: true },
              { type: "text",  content: "godina života," },
              
              { type: "text", newline:"true", content: "\r\n- radnikova obveza uzdržavanja" },
              { type: "input", value: "", required: true,   help: 'Upisati postoji li obveza uzdržavanja te ukoliko ista postoji, koliko osoba uzdržava.',},

             ],
  
            }
          ]
        },
    {
      title: '',
      mandatory: false,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako kod radnika postoji smanjenje radne sposobnosti uz preostalu radnu sposobnost, smanjenje radne sposobnosti uz djelomični gubitak radne sposobnosti ili neposredna opasnost od nastanka smanjenja radne sposobnosti koju je utvrdilo ovlašteno tijelo u skladu s posebnim propisom, poslodavac je dužan poduzeti zakonom određene mjere da radniku osigura odgovarajuće poslove. Ukoliko radnik odbije takve poslove ili poslodavac ne može radniku osigurati takve poslove, tek onda može otkazati ugovor o radu uz pridržavanje zakonom određenih uvjeta - suglasnost radničkog vijeća i sl..',
          content: 'Radnika nije moguće zaposliti na drugim odgovarajućim poslovima niti obrazovati ili osposobiti za rad na drugim poslovima, jer ne postoji niti jedno slobodno radno mjesto kod poslodavca na kojem bi se Radnik nakon takvog obrazovanja ili osposobljavanja mogao zaposliti.'
        }]
    },
    {
      title: '',
      mandatory: false,
      dummy: true,
      statements: [
        {
          type: 'choice',
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće pozitivno očitovalo dana ' },
                { type: 'input', value: '', required: true, help: 'Prije odluke o otkazu, poslodavac se dužan savjetovati s radničkim vijećem, ukoliko isto postoji kod poslodavca. Radničko vijeće je dužno u roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu.' },
              ]
            },
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik očitovao pozitivno dana ' },
                { type: 'input', value: '', required: true, help: 'Ako kod poslodavca nije utemeljeno radničko vijeće, a kod Poslodavca djeluje sindikalni povjerenik, isti preuzima sva prava i obveze radničkog vijeća te je u tom smislu dužan ju roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. U tom smislu, Poslodavac je dužan prije otkaza, prethodno se savjetovati sa sindikalnim povjerenikom.' },
              ]
            },
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće nije očitovalo u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga.' },
              ]
            },
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik nije očitovao u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga.' },
              ]
            },
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio radničkom vijeću namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se radničko vijeće očitovalo negativno, no Poslodavac ipak donosi ovu Odluku.' },
              ]
            },
            {
              parts: [
                { type: 'text', content: 'Poslodavac je dana ' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: 'godine priopćio sindikalnom povjereniku namjeru otkazivanja ugovora o radu uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj Radnika, o čemu se sindikalni povjerenik očitovao negativno, no Poslodavac ipak donosi ovu Odluku.' },
              ]
            }],
  
        },
      ]
    },
    {
      title: '',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Slijedom toga, a sukladno Zakonu o radu i Pravilniku o radu odlučeno je kako je navedeno u ovoj Odluci.\r\nTrajanje i tijek otkaznog roka iz ove Odluke utvrđeni su sukladno čl. 121. i 122. Zakona o radu i Pravilnika o radu.\r\nPravo Radnika na otpremninu iz ove Odluke utvrđeno je na temelju čl. 126. Zakona o radu i Pravilnika o radu.\r\nSlijedom iznesenog, donesena je ova Odluka.'
        }]
    },
    {
      title: 'NAPUTAK O ZAŠTITI PRAVA',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: false,
          content: 'Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke.'
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
    {
      static: true,
      mandatory: true,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
          content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
        },
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/8.1_poslovno_uvjetovani_otkaz_gospodarski.1.ts